export default __webpack_public_path__ + "static/media/kitSelectionDynamex@2x.4737353e.png";